// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"cce4a008","617":"59c806c9","840":"26bdfcdf"}[chunkId] + ".chunk.js";
};